import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Dropdown } from "antd";
import { RiArrowDownSLine, RiCheckLine, RiCloseLine } from "react-icons/ri";

import {
  Trigger,
  Placeholder,
  Chip,
  ChipRemove,
  Chevron,
  Menu,
  MenuItem,
  EmptyMenu,
} from "./styles";

const MultiSelect = ({
  value = [],
  onChange = () => {},
  options = [],
  placeholder,
  disabled = false,
}) => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);

  const toggleValue = (optionValue) => {
    const next = value.includes(optionValue)
      ? value.filter((v) => v !== optionValue)
      : [...value, optionValue];
    onChange(next);
  };

  const removeValue = (optionValue, event) => {
    event.stopPropagation();
    onChange(value.filter((v) => v !== optionValue));
  };

  const overlay = (
    <Menu>
      {options.length === 0 ? (
        <EmptyMenu>{intl.formatMessage({ id: "not_found" })}</EmptyMenu>
      ) : (
        options.map((option) => {
          const selected = value.includes(option.value);
          return (
            <MenuItem
              key={option.value}
              type="button"
              $selected={selected}
              onClick={() => toggleValue(option.value)}
            >
              <span>{option.label}</span>
              {selected && <RiCheckLine size={16} />}
            </MenuItem>
          );
        })
      )}
    </Menu>
  );

  return (
    <Dropdown
      dropdownRender={() => overlay}
      trigger={disabled ? [] : ["click"]}
      open={open && !disabled}
      onOpenChange={setOpen}
      placement="bottomLeft"
    >
      <Trigger $open={open} $disabled={disabled}>
        {value.length === 0 && <Placeholder>{placeholder}</Placeholder>}
        {value.map((v) => {
          const option = options.find((o) => o.value === v);
          if (!option) return null;
          return (
            <Chip key={v}>
              {option.label}
              <ChipRemove type="button" onClick={(e) => removeValue(v, e)}>
                <RiCloseLine size={12} />
              </ChipRemove>
            </Chip>
          );
        })}
        <Chevron $open={open}>
          <RiArrowDownSLine size={16} />
        </Chevron>
      </Trigger>
    </Dropdown>
  );
};

export default MultiSelect;
